<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent width="1000" scrollable>
      <v-card>
        <v-toolbar dark dense>
          <v-toolbar-title class="headline"
            >Edit Special close/open</v-toolbar-title
          >
          <v-spacer />
          <v-icon @click="$emit('setDialog', false)">close</v-icon>
        </v-toolbar>
        <v-card-text>
          <center>
            <editSpecialTimeForm
              v-if="show_form == true"
              @resetForm="setForm()"
              :form="form"
              @save="saveAdd()"
              @cancel="cancelAdd()"
            />
          </center>
          <v-btn
            absolute
            dark
            fab
            top
            right
            color="primary"
            style="top: 60px"
            @click="addSpecial()"
            v-if="show_form != true && !isEditStoreList"
          >
            <v-icon color="black">add</v-icon>
          </v-btn>
          <v-data-table
            :headers="headers"
            :items="store_special"
            hide-actions
            class="head-time"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-center" style="padding: 15px">
                {{ props.item.store_close_date }}
              </td>
              <td class="text-xs-center" style="padding: 15px">
                {{ props.item.store_close_msg }}
              </td>
              <td class="text-xs-left" style="padding-right: 0">
                {{ props.item.store_close_note }}
              </td>
              <td class="text-xs-center" style="padding: 0; width: 105px">
                <v-btn
                  icon
                  @click="delSpecial(props.item, props.index)"
                  :disabled="isEditStoreList"
                  :loading="
                    deleteing_special.includes(props.item.store_close_id)
                  "
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
              </td>
            </template>

            <template slot="no-data">
              <center>
                <h3>ไม่มีวันหยุดพิเศษ</h3>
              </center>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import editSpecialTimeForm from "./EditSpecialTimeForm";
import { mapState, mapGetters } from "vuex";
export default {
  props: ["dialog"],
  components: {
    editSpecialTimeForm,
  },
  data() {
    return {
      deleteing_special: [],
      form: null,
      show_form: false,
      headers: [
        {
          text: "Date",
          align: "center",
          value: "store_close_date",
          sortable: false,
        },
        {
          text: "Type",
          align: "center",
          value: "store_close_msg",
          sortable: false,
        },
        {
          text: "Note",
          align: "center",
          value: "store_close_note",
          sortable: false,
        },
        {
          text: "Actions",
          align: "center",
          value: "action",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      store_special: (state) => state.fetchStoreBack.store_detail.store_close,
      store_detail: (state) => state.fetchStoreBack.store_detail,
    }),
    ...mapGetters(["isEditStoreList"]),
  },
  methods: {
    async delSpecial(data, index) {
      this.deleteing_special.push(data.store_close_id);
      await this.$store.dispatch("fetchStoreBack/delSpecialTime", data);
      let key = this.deleteing_special.findIndex(
        (val) => data.store_close_id == val
      );
      this.deleteing_special.splice(key, 1);
    },
    setForm() {
      this.form = {
        store_close_pattern_weekday: null,
        store_close_pattern_weeknum: null,
        store_close_type: null,
        store_close_note: null,
        store_close_period: null,
        store_close_date_start: null,
        store_close_date_end: null,
        store_close_date: null,
        store_close_store_id: this.store_detail.store.store_id,
      };
    },
    addSpecial() {
      this.show_form = true;
      this.setForm();
    },
    saveAdd() {
      this.setForm();
      // this.show_form = false;
    },
    cancelAdd() {
      this.show_form = false;
    },
    initialize() {},
  },
  created() {
    this.initialize();
  },
};
</script>